module.exports = __webpack_public_path__ + "img/rocking-chairs-06.ecc71ac6.jpeg";